<template>
  <div class="Renaming-child container-fluid">
    <div class="row">
        <div class="col mainBar">
          <div >
            <div v-bind:toolSelection="selected">
              <div class="col topText">
                <div class="title">
                  {{tool[0].title}}
                </div>
                <div class="techUsed">
                  {{tool[0].techUsed}}
                </div>
                <div class="content">
                  {{tool[0].content}}
                </div>
              </div>
            </div>
          </div> 

          <div>
            <div class="row">
              <div class="col">
                <div class="mini-screenshots">
                  <img :src="tool[0].image1">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="mini-screenshots">
                  <img :src="tool[0].image3">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="screenshots">
                  <img :src="tool[0].image4">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="issues">
                  <b>Source Code:</b> <span style="font-style:italic"> {{tool[0].sourceCodeAvailability}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'Renaming-child',
  data:() =>({
    tool: [{
      title: "Smart File Renaming",
      techUsed: "Python3.5 ,NLTK (natural language processing library),PySide2 (GUI) ,PyInstaller (generate the .exe) ,Virtualenv (encapsulation of dependencies)",
      content: "This tool was developed to clean up the names of hundreds of badly named files. Using NLTK, the tool removes all bad characters or terms not understood, leaving only the recognized words in camelCase format.\n\nCet outil a été développé pour nettoyer les noms de centaines de fichiers mal nommés. À l'aide de NLTK, l'outil supprime tous les mauvais caractères ou termes non compris, ne laissant que les mots reconnus au format camelCase.",
      sourceCodeAvailability: "Unavailable, proprietary code",
      image1: require("@/assets/tools/RenamingFiles/Before_filesName.png"),
      image3: require("@/assets/tools/RenamingFiles/outputs.png"),
      image4: require("@/assets/tools/RenamingFiles/Renaming_GUI.png"),
    }]
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Geo&display=swap');

.Renaming-child{
  font-family: 'Roboto', sans-serif;
  max-width: 700px;
  white-space:pre-wrap;
}
.topText{
  display: block;
}
.title{
    font-family: 'Geo', sans-serif;
  text-align:center;
  font-weight: 700;
  font-size: 1.5em;
  margin-bottom: 2%;
}
.techUsed{
  font-style: italic;
  font-weight: 100;
  font-size: 0.7em;
  text-align: justify;
  margin-bottom: 3%;
}
.content{
  text-align: justify;
  margin-bottom: 4%;
  text-align: justify;
  font-size: 0.8em;
}
.screenshots{
  text-align:center;
  margin-left: 1%;
  margin-right: 1%;
  padding-bottom: 3%;
  height: auto;
}
.mini-screenshots{
    text-align:center;
  margin-left: 25%;
  margin-right: 25%;
  padding-bottom: 3%;
  height: auto;
}
.issues{
  text-align: center;
  font-size: 0.7em;
}
img{
  width:100%;
  height: 100%;
}
</style>
